module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_mora-54dfa69bd6b46ee34cbe43499dd26ab4.png";